import { makeRequestAuth } from "../utils/globals";

class CodeCampaignService {
  /*
   * @param null
   * @returns {promise}
   * it fetches list of all default preference
   */
  getPreference() {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_preference",
        tag: "storeAdmin",
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param selected campaign site_id
   * @returns {promise}
   * it fetches all selected params for selected site
   */
  getUpdatedPreference(site_id) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_pref_updated",
        tag: "storeAdmin",
        variables: {
          site_id: { site_id: parseInt(site_id) },
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  country list as a string
   * @returns {promise}
   * it fetches list of all cities for selected experience country
   */
  getExperienceCities(countries) {
    return new Promise((resolve, reject) => {
      let expCityFilter = {
        country_id: countries,
        key: "vd",
        limit: 1000,
        offset: 0,
        called_from: "store_admin",
      };
      const request_data = {
        query: "storesAdmin.mutation.get_exp_cities",
        tag: "storeAdmin",
        variables: {
          exp_city_filter: expCityFilter,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * it fetches all exp products based on given filters
   */
  getExperienceProduct(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.get_exp_products",
        tag: "storeAdmin",
        variables: {
          exp_prod_filter: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * it fetches all voucher products based on given filters
   */
  getVoucherProduct(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_product_list",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * it fetches all voucher products based on given filters
   */
  getMerchandiseProduct(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_product_list",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getTopupProduct(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_product_list",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * it fetches count of products in category bases on filters
   */
  getFilteredProductCount(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.filter_category",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * it fetches all voucher products based on given filters
   */
  getPerksProduct(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.voucher_perks_list",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * updates the name and status of site
   */
  updateSite(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.update_site",
        tag: "storeAdmin",
        variables: {
          site_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * creates a new campaign site
   */
  createSite(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.add_site",
        tag: "storeAdmin",
        variables: {
          site_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * creates a new campaign site
   */
  updatePrefrence(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.product_update",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  filters
   * @returns {promise}
   * this handles all action from creating, updating campaign as well as updating product of campaign
   */
  createUpdateCampaign(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.create_update_campaign",
        tag: "storeAdmin",
        variables: {
          ...params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  /*
   * @param  limit and page for pagination, blank to fetch all
   * @returns {promise}
   * returns list of all xoxo code campaign
   */
  fetchVoucherSites(params = {}) {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.site_list",
        tag: "storeAdmin",
        variables: {
          site_data: params,
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (response && response.data) {
            resolve(response.data);
          } else {
            resolve({});
          }
        }.bind(this)
      );
    });
  }

  /*
   * @param  limit and page for pagination, blank to fetch all
   * @returns {promise}
   * returns list of all voucher brands
   */
  getVoucherBrandsChips(params = {}) {
    return new Promise((resolve, reject) => {
      const getVoucherChips = {
        query: "storesAdmin.mutation.voucher_prod_filter",
        tag: "storeAdmin",
        variables: params,
      };
      makeRequestAuth(
        getVoucherChips,
        function (response) {
          if (response && response.data) {
            resolve(response.data);
          } else {
            resolve({});
          }
        }.bind(this)
      );
    });
  }
}

export default Object.freeze(new CodeCampaignService());
